function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r)
    i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;
else {
    var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); };
    o("next", 0), o("throw", 1), o("return", 2);
} }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { Avatar, Badge, Box, Button, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Popover, Stack } from '@mui/material';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import React from 'react';
import { AuthorizationAPI } from '../apis';
import { constants } from '../constants';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import styled from '@emotion/styled';
var style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    outline: 0
};
var OnlineBadge = styled(Badge)(function (_ref) {
    var size = _ref.size;
    return {
        '& .MuiBadge-badge': {
            backgroundColor: '#2E7D32',
            // Green color
            color: '#2E7D32',
            boxShadow: "0 0 0 2px white",
            borderRadius: '50%',
            height: "".concat(size, "px"),
            minWidth: "".concat(size, "px")
        }
    };
});
export default function LogoutModal() {
    var _user$userAttributes3, _user$userAttributes4;
    var _React$useState = React.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), open = _React$useState2[0], setOpen = _React$useState2[1];
    var handleOpen = function handleOpen() {
        return setOpen(true);
    };
    var handleClose = function handleClose() {
        return setOpen(false);
    };
    var navigate = useNavigate();
    var _React$useState3 = React.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), anchorElLogout = _React$useState4[0], setAnchorElLogout = _React$useState4[1];
    var handleProfileMenuOpen = function handleProfileMenuOpen(event) {
        setAnchorElLogout(event.currentTarget);
    };
    var handleCloseLogout = function handleCloseLogout(event) {
        console.log('Close Logout Popover');
        event.stopPropagation();
        setAnchorElLogout(null);
    };
    var _React$useState5 = React.useState({}), _React$useState6 = _slicedToArray(_React$useState5, 2), user = _React$useState6[0], setUser = _React$useState6[1];
    React.useEffect(function () {
        var _Cookies$get;
        // Perform localStorage action
        setUser(JSON.parse((_Cookies$get = Cookies.get('user')) !== null && _Cookies$get !== void 0 ? _Cookies$get : '{}'));
    }, []);
    var logout = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.n) {
                        case 0:
                            _context.n = 1;
                            return AuthorizationAPI.logout().then(function () {
                                sessionStorage.clear();
                                Cookies.remove('access_token');
                                Cookies.remove('refresh_token');
                                Cookies.remove('user');
                                Cookies.remove('ui_trace_id');
                                sessionStorage.clear();
                                navigate('/');
                                handleClose();
                            });
                        case 1:
                            return _context.a(2);
                    }
            }, _callee);
        }));
        return function logout() {
            return _ref2.apply(this, arguments);
        };
    }();
    var getInitials = function getInitials() {
        var _user$userAttributes;
        if (user !== null && user !== void 0 && (_user$userAttributes = user.userAttributes) !== null && _user$userAttributes !== void 0 && _user$userAttributes.name) {
            var _user$userAttributes2;
            var name = user === null || user === void 0 || (_user$userAttributes2 = user.userAttributes) === null || _user$userAttributes2 === void 0 ? void 0 : _user$userAttributes2.name.split(',');
            if (name.length > 1) {
                return "".concat(name[1].trim()[0]).concat(name[0].trim()[0]);
            }
            else {
                return "".concat(name[0].trim()[0]);
            }
        }
        return '';
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
        "aria-label": "account of current user",
        "aria-haspopup": "true",
        onClick: handleProfileMenuOpen,
        "data-testid": "logout-details",
        sx: {
            p: 0,
            mr: -0.5,
            backgroundColor: '#EBEBEB',
            borderRadius: '50%',
            minWidth: '32px',
            minHeight: '32px',
            width: '32px',
            height: '32px',
            color: '#595959'
        },
        variant: "text"
    }, /*#__PURE__*/ React.createElement(OnlineBadge, {
        overlap: "circular",
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        },
        variant: "dot",
        size: 10
    }, /*#__PURE__*/ React.createElement(Avatar, {
        sx: {
            bgcolor: '#e0e0e0',
            color: '#424242',
            width: 32,
            height: 32
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "#595959",
        fontWeight: 600
    }, getInitials())))), /*#__PURE__*/ React.createElement(Popover, {
        open: Boolean(anchorElLogout),
        anchorEl: anchorElLogout,
        onClose: handleCloseLogout,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        }
    }, /*#__PURE__*/ React.createElement(List, {
        sx: {
            width: '360px',
            bgcolor: 'background.paper'
        }
    }, /*#__PURE__*/ React.createElement(ListItem, null, /*#__PURE__*/ React.createElement(Box, {
        display: "flex",
        alignItems: "center",
        gap: 2
    }, /*#__PURE__*/ React.createElement(OnlineBadge, {
        overlap: "circular",
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right'
        },
        variant: "dot",
        size: 12
    }, /*#__PURE__*/ React.createElement(Avatar, {
        sx: {
            bgcolor: '#e0e0e0',
            color: '#424242',
            width: 40,
            height: 40
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "#595959",
        fontWeight: 600
    }, getInitials()))), /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        fontWeight: "700",
        color: "#212121"
    }, user === null || user === void 0 || (_user$userAttributes3 = user.userAttributes) === null || _user$userAttributes3 === void 0 ? void 0 : _user$userAttributes3.name), /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        color: "#595959",
        fontWeight: 700
    }, user === null || user === void 0 || (_user$userAttributes4 = user.userAttributes) === null || _user$userAttributes4 === void 0 ? void 0 : _user$userAttributes4.email)))), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            my: 1
        }
    }), /*#__PURE__*/ React.createElement(ListItem, {
        disablePadding: true,
        onClick: function onClick(event) {
            navigate('/settings');
            handleCloseLogout(event);
        },
        "data-testid": "settings-item"
    }, /*#__PURE__*/ React.createElement(ListItemButton, null, /*#__PURE__*/ React.createElement(ListItemIcon, null, /*#__PURE__*/ React.createElement(SettingsIcon, null)), /*#__PURE__*/ React.createElement(ListItemText, {
        primary: "Settings"
    }))), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            my: 1
        }
    }), /*#__PURE__*/ React.createElement(ListItem, {
        disablePadding: true,
        onClick: function onClick(event) {
            handleOpen();
            handleCloseLogout(event);
        },
        "data-testid": "logout-item"
    }, /*#__PURE__*/ React.createElement(ListItemButton, null, /*#__PURE__*/ React.createElement(ListItemIcon, null, /*#__PURE__*/ React.createElement(LogoutIcon, null)), /*#__PURE__*/ React.createElement(ListItemText, {
        primary: "Logout"
    }))))), /*#__PURE__*/ React.createElement(Modal, {
        open: open,
        onClose: handleClose,
        "aria-labelledby": "modal-modal-title",
        "aria-describedby": "modal-modal-description"
    }, /*#__PURE__*/ React.createElement(Paper, {
        sx: style
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "modal-modal-title",
        variant: "body1"
    }, constants.exit_msg, " ?"), /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        spacing: 2,
        paddingTop: 2
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "outlined",
        color: 'success',
        onClick: handleClose,
        "data-testid": "logout-cancel"
    }, constants.cancel), /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        color: 'success',
        onClick: function onClick() {
            logout();
        },
        "data-testid": "logout-logout"
    }, constants.logout)))));
}
